/** Faculty workbench (action-oriented). */
export const FACULTY_DASHBOARD_PATH = '/faculty/dashboard';

/** Faculty Diary — primary daily workspace (Phase 2.5). */
export {
  FACULTY_DIARY_PATH,
  FACULTY_DIARY_DAY_PATH,
  FACULTY_LESSON_PLANS_PATH,
  FACULTY_TEACHING_REPORTS_PATH,
  FACULTY_SESSION_LIBRARY_PATH,
} from './facultyDiary';

/** Student directory & management. */
export const FACULTY_STUDENTS_PATH = '/faculty/students';

/** Evaluation work queues. */
export const FACULTY_LAB_REVIEWS_PATH = '/faculty/lab-results';
export const FACULTY_PROJECT_REVIEWS_PATH = '/faculty/projects';

/** Recent events & coding activity timeline (CBC). */
export const FACULTY_ACTIVITY_FEED_PATH = '/faculty/activity-feed';

/** Coding Workspace — operational faculty surfaces. */
export const FACULTY_WORKSPACE_BASE = '/faculty/workspace';
export const FACULTY_WORKSPACE_OVERVIEW_PATH = `${FACULTY_WORKSPACE_BASE}/overview`;
export const FACULTY_BATCHES_PATH = `${FACULTY_WORKSPACE_BASE}/batches`;
export const FACULTY_ASSIGNMENTS_PATH = `${FACULTY_WORKSPACE_BASE}/assignments`;
export const FACULTY_INTERVENTIONS_PATH = `${FACULTY_WORKSPACE_BASE}/interventions`;

/** Legacy batch list URL (redirects to {@link FACULTY_BATCHES_PATH}). */
export const LEGACY_FACULTY_BATCHES_PATH = '/faculty/coding-dashboard';
